/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { Card as UICard } from './ui/card';
import { cn } from '../lib/utils';

class Card extends React.Component {
  constructor(props) {
    super(props);
    this.state = { foo: 'bar' };
  }

  render() {
    const { className, ...rest } = this.props;
    return (
      <UICard
        {...rest}
        className={cn('bg-white p-6 min-h-[50px] leading-relaxed shadow-sm hover:shadow-md transition-shadow duration-200', className)}
      >
        {this.props.children}
      </UICard>
    );
  }
}

export default Card;
